import {
    type MotionIntentType,
    type MotionTiming,
    getMotionTiming,
    type MotionType
} from "./timing";
import useReducedMotion from "./useReducedMotion";
import {
    NCoreUIKitTheme
} from "../../core/hooks";

export type MotionThemeType = Parameters<typeof NCoreUIKitTheme.useContext>[0];

export type MotionTimingHookType = MotionTiming & {
    isReduceMotionEnabled: boolean;
};

const useMotionTiming = (intent: MotionIntentType, customTheme?: MotionThemeType, motion?: MotionType): MotionTimingHookType => {
    const {
        durations
    } = NCoreUIKitTheme.useContext(customTheme);

    const isReduceMotionEnabled = useReducedMotion();

    return {
        ...getMotionTiming({
            isReduceMotionEnabled,
            durations,
            motion,
            intent
        }),
        isReduceMotionEnabled
    };
};
export default useMotionTiming;
